import websiteImg from '~/assets/images/cross-sell/GuestList.svg';
import { GUEST_LIST_HREF } from '~/util/crossSell';

import { CrossSellCard } from './CrossSellCard';

import styles from './crossSellGuestList.module.less';

export const CrossSellGuestList = ({ handleClick }: { handleClick: () => void }) => {
  const preview = (
    <div className={styles.crossSellStaticPreview}>
      <img src={websiteImg} alt="" className={styles.staticImage} />
    </div>
  );
  return (
    <CrossSellCard
      hed={"While you're here, add your first guests"}
      cta="Start guest list"
      href={GUEST_LIST_HREF}
      onClick={handleClick}
      className={styles.crossSellGuestList}
      preview={preview}
    />
  );
};

export default CrossSellGuestList;
